import React, { Component } from "react";

import { CModal, CModalHeader, CModalTitle } from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { Row } from "reactstrap";
import { bindActionCreators } from "redux";

import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import ApplicatedQuestionList from "../../../../components/ApplicatedQuestionList/ApplicatedQuestionList";
import Breadcrumb from "../../../../components/Breadcrumb";
import Loading from "../../../../components/Loading";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import DataTable from "../../../../components/Tables/tables";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";
import Statistics from "../../List/statistics";

class EvaluationBankList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      list: [],
      loading: true,
      enableShowEvaluationModal: false,
      isAlagoasGroup: false
    };

    this.error = this.error.bind(this);
    this.allocateAction = this.allocateAction.bind(this);
  }

  error = response => {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Falha", response);
    }
  };

  componentDidMount() {
    if (this.props.user.user_roles) {
      let aux = this.props.user.user_roles.find(
        elem => elem.group_name === "Escola 10 Digital"
      );
      if (aux) {
        this.setState({ isAlagoasGroup: true });
      }
    }

    this.props.setObj(16, this.props.currentRoute, this.props.currentRoute);

    this.handleTrails();
  }

  handleTrails() {
    this.setState({ loading: true });
    const obj = {
      private: false,
      group_id: 86,
      type_id: 4
    };

    axios
      .post(`${URL.api}activity/activity/listEvaluationsByGroupAdm`, obj, {
        headers: { authorization: `Bearer ${this.props.user.token}` }
      })
      .then(resp => {
        this.setState({
          list: resp.data.data,
          loading: false
        });
      });
  }

  allocateAction = row => {
    this.props.history.push(`/evaluation/bank/allocate/${row.id}`);
  };

  reportAction = row => {
    this.setState({ statisticsModal: true, selectedActivityId: row.id });
  };

  viewAction = row => {
    this.props.history.push(`/activity/show/${row.id}`);
  };

  printAction = row => {
    let objAllocate = {
      activity_id: row.id,
      room_id: 0,
      user_id: 0
    };

    axios
      .post(`${URL.api}activity/allocate/list`, objAllocate, {
        headers: { Authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          if (resp.data.data.length > 0) {
            const currentRoute = this.props.match.url; // obtém a rota atual
            const nextRoute = `/evaluation/print/${row.id}`;
            this.props.history.push(nextRoute, { previousRoute: currentRoute });
          } else {
            toastr.error(
              "Erro",
              "Você precisa alocar a lista em alguma turma primeiro."
            );
          }
        },
        error => {
          this.error(error.response.statusText);
        }
      );
  };

  render() {
    return (
      <>
        {this.state.statisticsModal && (
          <Statistics
            show
            onClose={() => this.setState({ statisticsModal: false })}
            activity_id={this.state.selectedActivityId}
            currentRoute={this.props.currentRoute}
            title={
              this.state.list.find(
                item => item.id === this.state.selectedActivityId
              )?.nome
            }
          />
        )}
        {true && (
          <CModal
            show={this.state.enableShowEvaluationModal}
            onClose={() =>
              this.setState({
                enableShowEvaluationModal: false
              })
            }
            size="lg w-100 h-100 m-0 p-2 mw-100"
            style={{ width: "100%", height: "100%" }}
            closeOnBackdrop={false}
          >
            <CModalHeader closeButton>
              <CModalTitle>Avaliação</CModalTitle>
            </CModalHeader>
            {/* {this.state.listQuestion.show && (
              <ApplicatedQuestionList
                viewModal
                activityId={this.state.selectedActivityId}
                currentRoute={this.props.currentRoute}
                allocation_id={this.state.allocation_id}
                id={this.state.listQuestion.id}
                history={this.props.history}
                prototype={false}
                item_id={this.state.item_id}
                execution_id={this.state.execution_id}
                result_type={this.state.activity.result_type}
                close={() =>
                  this.setState(
                    prevState => ({
                      listQuestion: {
                        id: prevState.listQuestion.id,
                        show: false
                      },
                      showViewModal: true
                    }),
                    () => this.handleActivity()
                  )
                }
                end_date={this.state.activity.activity_end}
              />
            )} */}
          </CModal>
        )}
        <div className="animated fadeIn">
          <Row>
            <Breadcrumb current={this.props.currentRoute} />
            {this.state.loading ? (
              <Loading top="45" left="50" />
            ) : (
              <>
                {this.state.list ? (
                  <div id="list">
                    <DataTable
                      list={this.state.list}
                      title="Banco de Avaliações"
                      header={[
                        { name: "id", denomination: "ID" },
                        { name: "name", denomination: "Nome" },
                        { name: "description", denomination: "Descrição" },
                        { name: "author", denomination: "Usuário" }
                      ]}
                      action
                      btnView
                      viewAction={this.viewAction}
                      btnAllocate={
                        !this.props.user.user_roles.some(
                          role => role.role_id === 2
                        )
                      }
                      btnReport={!this.state.isAlagoasGroup}
                      btnPrint
                      printAction={this.printAction}
                      allocateAction={this.allocateAction}
                      reportAction={this.reportAction}
                    />
                  </div>
                ) : (
                  <Loading />
                )}
              </>
            )}
          </Row>
        </div>
        <ProtectedRoute routeId={this.props.currentRoute} />
      </>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(EvaluationBankList);
